/**
 * 使用场景：添加买家tale结果
 * */
import React, { Component } from 'react';
import { connect } from '@souche-f2e/muji';
import { Table, Button, Modal } from 'antd';
import { TableContainer } from '@/components';
import { dispatch } from '@@/store';
import { AddBuyer, CodeEdit, BankCode, ClearCodeModal, EditMsg } from './index';
import Authorized from '@/components/Auth/auth';
import { dealListValueShow } from '@/shared/functions';
import { fontEndConfig } from '@/shared/utils';
const mapStateToProps = (rootState) => ({
    buyer: rootState.buyer,
});
class TableResult extends Component {
    constructor(props) {
        super(props);
        this.state = {
            column: [
                {
                    title: '序号',
                    fixed: 'left',
                    dataIndex: 'index',
                    width: 100,
                    render: (text, record, index) => {
                        const pageIndex = this.props.buyer.pageIndex - 1;
                        const pageSize = this.props.buyer.pageSize;
                        return (<span>{(pageIndex * pageSize) + index + 1}</span>);
                    },
                },
                {
                    title: '用户id',
                    dataIndex: 'userId',
                    fixed: 'left',
                    width: 150,
                },
                {
                    title: '姓名',
                    dataIndex: 'realName',
                    fixed: 'left',
                    width: 150,
                },
                {
                    title: '类型',
                    dataIndex: 'userType',
                },
                {
                    title: '身份证号',
                    dataIndex: 'contactCode',
                },
                {
                    title: '号牌',
                    dataIndex: 'numberPlate',
                },
                {
                    title: '手机号',
                    dataIndex: 'mobile',
                },
                {
                    title: '维护人',
                    dataIndex: 'maintainer',
                },
                {
                    title: '所在地',
                    dataIndex: 'provinceName',
                    render: (name, rowData) => name === fontEndConfig.noValueReplace ? name : (<span>{name}/{rowData.cityName}</span>),
                },
                {
                    title: '买家添加时间/注册时间',
                    dataIndex: 'createTime',
                },
                {
                    title: '银行卡号',
                    dataIndex: 'moneyCode',
                    render: (text, rowData, index) => (<a href="javascript:;" onClick={() => {
                        this.showBankCode(rowData);
                    }}>
              查看
            </a>),
                },
                {
                    title: '操作',
                    dataIndex: 'operate',
                    fixed: 'right',
                    width: 150,
                    render: (text, rowData, index) => {
                        const { numberPlate, authenticated } = rowData;
                        if (authenticated === '0') {
                            return (<a onClick={() => {
                                dispatch.buyer.SHOW_ADD_MODAL(rowData);
                            }}>
                  实名认证
                </a>);
                        }
                        if (numberPlate !== fontEndConfig.noValueReplace) {
                            return (<div className={'table-operate-btn'}>
                  <Authorized allow={'psgjb-dealerbuyer-operate'}>
                    {this._renderEdit(rowData)}
                    {this._renderDelCode(rowData)}
                  </Authorized>
                </div>);
                        }
                        return (<div className={'table-operate-btn'}>
                {authenticated === '0' && (<a onClick={() => {
                            dispatch.buyer.SHOW_ADD_MODAL(rowData);
                        }}>
                      实名认证
                    </a>)}
                {(authenticated === '1' && numberPlate !== fontEndConfig.noValueReplace) ? (<Authorized allow={'psgjb-dealerbuyer-operate'}>
                      {this._renderEdit(rowData)}
                      {this._renderDelCode(rowData)}
                    </Authorized>) : (<Authorized allow={'psgjb-dealerbuyer-operate'}>
                      {this._renderEdit(rowData)}
                      {this._renderAddCode(rowData)}
                    </Authorized>)}
              </div>);
                    },
                },
            ],
        };
    }
    _renderAddCode(rowData) {
        return (<a onClick={() => {
            this.editCode(rowData);
        }}>
        添加号牌
      </a>);
    }
    _renderDelCode(rowData) {
        return (<a onClick={() => {
            this.delCode(rowData);
        }}>
        删除号牌
      </a>);
    }
    _renderEdit(rowData) {
        return (<a onClick={() => {
            dispatch.buyer.SHOW_EDIT(rowData);
        }}>
        编辑
      </a>);
    }
    // desc 切换页码
    changePageIndex(index) {
        dispatch.buyer.updateTable({ pageIndex: index });
    }
    // desc 删除号牌
    delCode(rowData) {
        Modal.confirm({
            title: '是否确认删除？',
            onOk: () => {
                dispatch.buyer.delPlate(rowData);
            },
        });
    }
    // 银行卡
    showBankCode(row) {
        dispatch.buyer.queryBankMsg(row);
    }
    // desc 修改号牌
    editCode(rowData) {
        dispatch.buyer.SHOW_CODE_EDIT(rowData);
    }
    render() {
        const { tableData, pageSize, pageIndex, total, } = this.props.buyer;
        const { column } = this.state;
        return (<React.Fragment>
        <TableContainer hasExport={false} totalNum={total}>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%' }}>
            <Button type={'primary'} onClick={() => {
            dispatch.buyer.SHOW_ADD_MODAL(false);
        }}>
              添加买家
            </Button>
            <Button type={'primary'} onClick={() => {
            dispatch.buyer.TOGGLE_CLEAR_CODE_MODAL();
        }}>
              一键清空号牌
            </Button>
          </div>
          <Table columns={column} dataSource={dealListValueShow({
            gistData: column,
            data: tableData,
        })} scroll={{
            x: '2100px',
        }} pagination={{
            current: pageIndex,
            defaultPageSize: pageSize,
            showQuickJumper: true,
            total,
            onChange: this.changePageIndex,
        }}/>
        </TableContainer>
        <AddBuyer />
        <CodeEdit />
        <BankCode />
        <ClearCodeModal />
        <EditMsg />
      </React.Fragment>);
    }
}
export default connect(mapStateToProps)(TableResult);
